import { put, takeEvery } from 'redux-saga/effects'

import { RewardPublicActions } from 'primsell-shared-layer/features'
import { RewardsAPI } from 'primsell-shared-layer/api'

import { IPublicReward, WrappedResponse } from 'primsell-shared-layer/types'

export function* getPublicRewardDetailsByCodeSaga(
  action: ReturnType<typeof RewardPublicActions.getPublicRewardDetailsByCodeRequest>
): Generator {
  try {
    const { code } = action.payload

    const {
      data: { data },
    } = (yield RewardsAPI.getPublicRewardDetailsByCode({ code })) as WrappedResponse<IPublicReward>

    yield put(RewardPublicActions.getPublicRewardDetailsByCodeSuccess(data))
  } catch (error: any) {
    yield put(RewardPublicActions.getPublicRewardDetailsByCodeFailure({ errorMessage: error.response.data.errorCode }))
  }
}

function* rewardPublicSagas(): Generator {
  yield takeEvery(RewardPublicActions.getPublicRewardDetailsByCodeRequest, getPublicRewardDetailsByCodeSaga)
}

export { rewardPublicSagas }
